var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg4VRight = function Svg4VRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.892 3.5 7.47 24l19.42 20.5h3.573l.08-.16 8.126-9.357.26-.3L41.066 24 38.93 13.316l-.26-.3-8.126-9.357-.08-.159zm3.667 34.104-1.95 3.896h-.427L17.499 30.222zm5.586-22.92L38.008 24l-1.864 9.315-1.657 1.91L37 24.337l.077-.337-.077-.337-2.512-10.889zm-4.618 20.021L15.24 25.5h18.412zM33.651 22.5H15.24l16.288-9.206zM30.56 10.396l-13.06 7.381L28.182 6.5h.427z"
  })));
};
export default Svg4VRight;